import { render, staticRenderFns } from "./VerticalBarsChart.vue?vue&type=template&id=55036a95&"
import script from "./VerticalBarsChart.vue?vue&type=script&lang=js&"
export * from "./VerticalBarsChart.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBarsChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinnerTail})
